import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Bootstrap from '../bootstrap';
import MicroComponent from '../common/MicroComponent';
import AdelaideRivieraHotelStay from '../../pactum-server/stubs/stayContentFactory';

const StaysDetailDrawer: React.FC = () => {
  const [open, setOpen] = useState(false);

  const args = {
    stayId: undefined,
    open: open,
    stay: AdelaideRivieraHotelStay({}),
    onAction: () => setOpen(false),
  };

  return (
    <Bootstrap>
      <Button size="small" color="success" onClick={() => setOpen(true)}>
        Open Drawer
      </Button>
      <MicroComponent micro={{ sdkName: SERVICE_SDK_NAME, componentName: 'StaysDetailDrawer' }} {...args} />
    </Bootstrap>
  );
};

export default StaysDetailDrawer;
